import React, { useRef } from "react";
import CinematicProductLayout, {
  CinematicHero,
  CinematicText,
  VelocityScroll,
  CinematicCardStack,
  ParallaxFeatures,
  AmbientParticles
} from "./shared/CinematicProductLayout";
import { Brain, Zap, Code, Database, Network, Lock, Workflow, Cpu, Scale, Activity, ArrowRight } from "lucide-react";
import { motion, useScroll, useTransform } from "motion/react";

const ZYPHERAI = () => {
    // Images - Ensure these exist or use placeholders that look good
    const bgImage = "/zypher1.png"; 
    const featureImage = "/zypher2.png"; 

  // Card Stack Items for "Capabilities"
  const stackItems = [
      { 
          title: "Clinical Advisory", 
          description: "Real-time decision support for healthcare professionals. Zypher analyzes clinical data to provide evidence-based insights.", 
          image: null
      },
      { 
          title: "Patient Risk Prediction", 
          description: "Detecting critical health deteriorations and disease onset before they manifest with clinical-grade accuracy.", 
          image: null 
      },
      { 
          title: "Medical Knowledge Graph", 
          description: "Dynamic mapping of patient history, genomic data, and clinical research for personalized care paths.", 
          image: null 
      },
       { 
          title: "Healthcare Compliance", 
          description: "Military-grade encryption and HIPAA standards ensuring patient data remains private and secure.", 
          image: null 
      }
  ];

  // Parallax Feature Items for "Deep Dive"
  const deepDiveItems = [
      {
          title: "Real-Time Care Monitoring",
          description: "Streaming vital analysis with sub-millisecond precision. Life-saving insights at the speed of thought.",
          image: "/zypherai.png"
      },
      {
          title: "Unified Medical Records",
          description: "Synchronizing fragmented healthcare data into a single, secure source of truth for seamless care coordination.",
          image: "/zypherai2.png"
      }
  ];

  return (
    <CinematicProductLayout>
      <AmbientParticles />
      {/* 1. HERO - Keeping the loved interactions */}
      <CinematicHero
        title="ZYPHER AI"
        subtitle="The Future of Healthcare Intelligence."
        bgImage={bgImage}
      />


      {/* 3. PHILOSOPHY - Scroll Reveal Text */}
      <section className="min-h-screen bg-zinc-950 flex flex-col items-center justify-center px-6 relative overflow-hidden">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-blue-900/10 via-black to-black" />
          <div className="max-w-4xl text-center relative z-10">
              <CinematicText className="text-3xl md:text-7xl font-medium text-white leading-tight px-4">
                  "Empowering care through empathetic intelligence."
              </CinematicText>
          </div>
      </section>

      {/* 4. CAPABILITIES - CINEMATIC CARD STACK (The "WOW" Factor) */}
      <section className="bg-black relative">
          <div className="py-24 text-center">
               <h2 className="text-sm font-bold text-blue-500 tracking-widest uppercase mb-4">Core Capabilities</h2>
               <h3 className="text-4xl md:text-6xl font-medium text-white">The Engine of Evolution</h3>
          </div>
          <CinematicCardStack items={stackItems} />
      </section>

      {/* 5. DEEP DIVE - PARALLAX FEATURES (Modern & Smooth) */}
      <ParallaxFeatures items={deepDiveItems} />

      {/* 6. CALL TO ACTION - Minimal & Strong */}
       <section className="h-[80vh] bg-black flex flex-col items-center justify-center text-center px-6 relative overflow-hidden">
             {/* Abstract Background */}
             <div className="absolute inset-0">
                 <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-blue-600/20 rounded-full blur-[120px] animate-pulse" />
             </div>
             
             <div className="relative z-10">
                <Workflow className="w-24 h-24 text-white/80 mb-12 mx-auto" strokeWidth={0.5} />
                <h2 className="text-5xl md:text-9xl font-medium text-white mb-12 tracking-tighter">HEAL</h2>
                <button className="group relative inline-flex h-12 md:h-14 items-center justify-center overflow-hidden rounded-full bg-transparent border border-white/20 px-8 md:px-12 font-medium text-white transition-all duration-500 hover:border-blue-500/50 hover:bg-white/5 backdrop-blur-sm">
                    <div className="absolute inset-0 bg-blue-500/0 transition-all duration-500 group-hover:bg-blue-500/10" />
                    <span className="mr-4 text-lg tracking-widest uppercase font-light">Integrate Zypher AI</span>
                    <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-3 text-blue-500" />
                 </button>
             </div>
       </section>
    </CinematicProductLayout>
  );
};

export default ZYPHERAI;
